export const INTERNAL_LOGIN_ROLES = ['admin', 'operator'] as const;

export type InternalLoginRole = (typeof INTERNAL_LOGIN_ROLES)[number];

export function isInternalLoginRole(role: string | undefined | null): boolean {
  return role === 'admin' || role === 'operator';
}

export const EXTERNAL_LOGIN_DENIED_MESSAGE =
  '本系統僅供內部人員使用，客戶與承攬夥伴無法登入';
